import { SuccessClientResponse } from '@orbis-systems/orbis-api-clients';
import { Account, GroupRtbs, PositionType, Rtbs, User } from '@orbis-systems/orbis-api-middleware';
import { queryOptions } from '@tanstack/react-query';
import { orbis } from '../api';
import { PortfolioWithExtraInfo } from '@/types';

export interface BranchPortfolioQueryParams {
    combined?: boolean;
    currency?: string;
    symbol?: string;
    positionType?: PositionType;
    enabled?: boolean;
}

export type BranchRtbsResponse = SuccessClientResponse<GroupRtbs[]>;
export type BranchInventoryResponse = SuccessClientResponse<Account[]>;
export type BranchRtbResponse = SuccessClientResponse<Rtbs>;
export type BranchPortfolioResponse = SuccessClientResponse<PortfolioWithExtraInfo>;
export type BranchUsersListResponse = SuccessClientResponse<User[]>;

export const branchQueries = {
    all: () =>
        queryOptions({
            queryKey: ['branch'],
        }),
    branchRtbs: () =>
        queryOptions<BranchRtbsResponse>({
            queryKey: [...branchQueries.all().queryKey, 'branchRtbs'],
            queryFn: () => orbis.branch.branchRtbs(),
        }),
    branchInventory: () =>
        queryOptions<BranchInventoryResponse>({
            queryKey: [...branchQueries.all().queryKey, 'branchInventory'],
            queryFn: () => orbis.branch.branchInventory(),
        }),
    branchRtb: () =>
        queryOptions<BranchRtbResponse>({
            queryKey: [...branchQueries.all().queryKey, 'branchRtb'],
            queryFn: () => orbis.branch.branchRtb(),
        }),
    branchPortfolio: (params: BranchPortfolioQueryParams) =>
        queryOptions<BranchPortfolioResponse>({
            queryKey: [...branchQueries.all().queryKey, 'branchPortfolio', params],
            queryFn: () =>
                orbis.branch.branchPortfolio({
                    // @ts-expect-error: // FIXME: missing query param (currency). Waiting for backend update
                    currency: params.currency,
                    combined: params.combined,
                    loadQuotes: true,
                    loadIndustries: true,
                    loadRtb: true,
                    marketCapBreakdown: true,
                }),
        }),
    usersList: () =>
        queryOptions<BranchUsersListResponse>({
            queryKey: [...branchQueries.all().queryKey, 'usersList'],
            queryFn: () => orbis.advisory.userAccountManagement.list(),
        }),
} as const;
